var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"preloader"}},[_c('div',{staticClass:"preloader-container"},[_c('div',{staticClass:"loader"}),_c('logo',{staticClass:"logo",attrs:{"fill":"#555fb9"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }